export default "<div class=\"utilisateur\">\n  {{UtilisateurInComponent}}\n</div>\n\n";